import { PartnerType } from "@/app/utils/partners.enum";
import { httpClient } from "../http/httpClient";

export interface UpdateConfigProductRequest {
  type: PartnerType;
  createLink: boolean;
  color?: string;
  subtitle?: string;
  title?: string;
  label?: string;
  description?: string;
  coopId?: number | null;
}

export async function updateConfigProduct(params: UpdateConfigProductRequest) {
  const { data } = await httpClient.patch<{ success: boolean }>(
    `/config/product`,
    params,
  );
  return data;
}
